import {RemoveButton, intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './UserFilter.less';
import {UserFilter as UserFilterModel} from 'src/js/model/user_filters';

const I18N = defineMessages({
  REMOVE: {
    id: 'filter.user.remove',
    defaultMessage: 'Remove user filter',
    description: 'title text for user filter remove button',
  },
  USE: {
    id: 'filter.user.apply',
    defaultMessage: 'Apply user filter',
    description: 'title text for user filter apply button',
  },
});

class UserFilter extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleDefaultChange = this.handleDefaultChange.bind(this);
  }

  /* eslint-disable react-hooks/rules-of-hooks */
  handleClick(event) {
    const {filter, useFilter} = this.props;
    event.stopPropagation();
    useFilter(filter);
  }
  /* eslint-enable react-hooks/rules-of-hooks */

  /* eslint-disable react-hooks/rules-of-hooks */
  handleKeyDown(event) {
    const {filter, useFilter} = this.props;
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      useFilter(filter);
    }
    return true;
  }
  /* eslint-enable react-hooks/rules-of-hooks */

  handleDefaultChange(event) {
    const {filter, setDefaultFilter} = this.props;
    const {target} = event;
    const value = target.checked;
    event.stopPropagation();
    setDefaultFilter(filter, value);
  }

  render() {
    const {componentString, filter, intl, removeFilter} = this.props;
    const title = `${utils.TranslateUtils.translate(
      I18N.USE,
      intl
    )} - ${filter.getName()} | ${componentString}`;
    return filter ? (
      <div className={styles.dlUserFilter}>
        <span className={styles.dlUserFilterButton}>
          <span
            className={styles.dlUseButton}
            title={title}
            onClick={this.handleClick}
            onKeyDown={this.handleKeyDown}
            tabIndex={0}
            role={'button'}
          >
            <i
              className={classNames({
                fas: true,
                'fa-filter': true,
                'styles.dlIconButton': true,
              })}
              disabled={false}
              title={title}
            />
            <span className={styles.dlUserFilterName}>{filter.getName()}</span>
          </span>
        </span>
        <span className={styles.dlUserFilterDefault}>
          <input
            type='checkbox'
            checked={filter.isDefault()}
            onChange={this.handleDefaultChange}
          />
        </span>
        <span className={styles.dlUserFilterRemoveButton}>
          <RemoveButton
            iconClass={'fas fa-trash-alt'}
            item={filter}
            removeCallback={removeFilter}
            titleText={I18N.REMOVE.id}
          />
        </span>
      </div>
    ) : null;
  }
}

UserFilter.displayName = 'UserFilter';

UserFilter.propTypes = {
  componentString: PropTypes.string.isRequired,
  filter: PropTypes.instanceOf(UserFilterModel).isRequired,
  intl: intlShape.isRequired,
  removeFilter: PropTypes.func.isRequired,
  setDefaultFilter: PropTypes.func.isRequired,
  useFilter: PropTypes.func.isRequired,
};

export default injectIntl(UserFilter);
